export const createRoadmapPublicLinkUrl = (publicLinkId: string) => {
  return `${window.location.origin}/view/${publicLinkId}`;
};
